import React, {lazy, Suspense} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';

import * as paths from 'paths';

import AppFooter from 'components/App/Footer/AppFooter';
import AppHeader from 'components/App/Header/AppHeader';
import Breadcrumbs from 'components/App/Header/Breadcrumbs';
import Page from 'components/App/Page';
import Logout from 'components/Authentication/Logout';
import A11ycat from 'components/A11ycat/A11ycat';
import Application from 'components/Application/Application';

import AuthenticationLayout from 'layouts/AuthenticationLayout';
import HomeLayout from 'layouts/HomeLayout';

import theme from 'styles/theme';

const Toaster = lazy(() => import(/* webpackChunkName: "toaster" */ 'components/Notifications/Toaster'));

export default function AppLayout() {

    const appStyles = {
        fontFamily: theme.font.main.family,
        fontSize: theme.font.main.size,
        color: theme.font.main.colour,

        background: theme.background.main,
        display: 'flex',
        width: '100%',
        flexDirection: 'column',
        alignContent: 'flex-start',
    };

    return <div style={appStyles}>
        <div style={{position: 'sticky', top: 0, zIndex: 100}}>
            <AppHeader/>
            <Breadcrumbs/>
        </div>
        <Page>
            <Routes>
                <Route path={paths.LOGIN + '/*'} element={<AuthenticationLayout/>}/>
                <Route path={paths.LOGOUT} element={<Logout/>}/>
                <Route path={paths.HOME} element={<HomeLayout/>}/>
                <Route path={paths.APPLICATION + "/:application/*"} element={<Application/>}/>
                <Route path="*" element={<Navigate to={paths.HOME}/>}/>
            </Routes>
        </Page>
        <AppFooter/>
        <Suspense fallback={null}>
            <Toaster/>
        </Suspense>
        <A11ycat/>
    </div>;
}

